import React from "react";
import ReactDOM from "react-dom";

import { ToastContainer } from "react-toastify";

import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import Theme from "./theme/Theme";

import App from "./App";
import { QueryParamsContextProvider } from "./context/QueryParamsContext";

import "./index.css";
import { StyledProvider } from "./theme/StyledProvider";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1A5DC9",
    },
    secondary: {
      main: "#3058a5e0",
    },
  },
});

ReactDOM.render(
  <>
    <ThemeProvider theme={theme}>
      <Theme>
        <StyledProvider>
          <ToastContainer />
          <QueryParamsContextProvider>
            <App />
          </QueryParamsContextProvider>
        </StyledProvider>
      </Theme>
    </ThemeProvider>
  </>,
  document.getElementById("root")
);
